module.exports = __webpack_public_path__ + "static/media/district4k.ce92df78.jpg";